import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

// QL-119 — `block` is load-bearing, not cosmetic: a bare <label> is `display:
// inline`, and vertical margins never apply to an inline box. Every field that
// wrapped its label and control in `space-y-2` was therefore rendering *no* gap
// at all, which is the "label almost touching the first option" report.
// A `className` that sets its own display (e.g. `inline-flex`) still wins —
// `cn` runs tailwind-merge, so the later display utility replaces this one.
const labelVariants = cva(
  "block text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
